import { Map } from 'immutable';

/*
Generic form for notifications:
{
  type: 'incorrect' || [...others]
  body: 'message'
}
 */

export function addMessage(state, message) {
  return state.push(new Map(message));
}

export function removeMessage(state, index = null) {
  if (index === null) {
    return state.pop();
  }

  return state.delete(index);
}

export function clearMessages(state) {
  return state.clear();
}



// WEBPACK FOOTER //
// ./src/store/messages/notifications/lib.js